import routes from '../../../setup/consts/routes';

/** Bump when a release adds tour-worthy features — a new key re-shows the
 * tour once to everyone (their old "seen" flag no longer matches). */
export const TOUR_STORAGE_KEY = 'sdg-center-tour-seen-v2.4';

export const START_TOUR_EVENT = 'sdg:start-feature-tour';

export interface TourStep {
  /** Route the step lives on — the tour navigates there. */
  route: string;
  /** data-tour attribute of the highlighted element; null = centered card. */
  target: string | null;
  titleId: string;
  defaultTitle: string;
  bodyId: string;
  defaultBody: string;
}

export const TOUR_STEPS: TourStep[] = [
  {
    route: routes.DASHBOARD,
    target: 'dashboard-kpis',
    titleId: 'tour.dashboard.title',
    defaultTitle: 'Your day at a glance',
    bodyId: 'tour.dashboard.body',
    defaultBody:
      "The dashboard tracks today's orders, work still pending, failed orders worth recovering, and your total SKUs — with financials and top sellers below.",
  },
  {
    route: routes.ORDERS,
    target: 'new-order',
    titleId: 'tour.newOrder.title',
    defaultTitle: 'A new way to place orders',
    bodyId: 'tour.newOrder.body',
    defaultBody:
      'Placing an order is now a guided 3-step flow: store & customer, products, then delivery & review.',
  },
  {
    route: routes.PLACE_ORDER,
    target: 'wizard-stepper',
    titleId: 'tour.stepper.title',
    defaultTitle: 'Three clear steps',
    bodyId: 'tour.stepper.body',
    defaultBody:
      'Move between steps freely — nothing blocks you until you place the order. Products are optional: you can send an order with just a value.',
  },
  {
    route: routes.PLACE_ORDER,
    target: 'wizard-total',
    titleId: 'tour.total.title',
    defaultTitle: 'You control the charged amount',
    bodyId: 'tour.total.body',
    defaultBody:
      'The total pre-fills from your products but stays editable — it is what your customer will be charged. Delivery fee and grand total update live down here.',
  },
  {
    route: routes.WAREHOUSE,
    target: 'warehouse-add-product',
    titleId: 'tour.warehouse.title',
    defaultTitle: 'A fully working warehouse',
    bodyId: 'tour.warehouse.body',
    defaultBody:
      'Add products, edit them on a real form, and manage photos — upload a cover image or remove images right from the edit page.',
  },
  {
    route: routes.FAILED_ORDERS,
    target: 'failed-orders',
    titleId: 'tour.failedOrders.title',
    defaultTitle: 'Recover lost revenue',
    bodyId: 'tour.failedOrders.body',
    defaultBody:
      'Every order that could not be delivered lands here with its reason. Filter by reason, then re-place or cancel — each one is revenue waiting to be recovered.',
  },
  {
    route: routes.FINANCIALS,
    target: 'financials-balances',
    titleId: 'tour.financials.title',
    defaultTitle: 'Follow your money',
    bodyId: 'tour.financials.body',
    defaultBody:
      'Your balances at the top — available, pending and withdrawn — with statements and settlement payouts below.',
  },
  {
    route: routes.REPORTS,
    target: 'reports-types',
    titleId: 'tour.reports.title',
    defaultTitle: 'Build any report',
    bodyId: 'tour.reports.body',
    defaultBody:
      'Pick a report — orders, financials, failed deliveries, customer activity or fulfilment. A panel opens where you set the date range and choose which columns to include, then Generate.',
  },
  {
    route: routes.REPORTS,
    target: 'reports-recent',
    titleId: 'tour.reportsBackground.title',
    defaultTitle: 'They generate in the background',
    bodyId: 'tour.reportsBackground.body',
    defaultBody:
      'No waiting on a spinner — reports build in the background and appear here. You’ll see “Generating…”, then “Ready” with a Download link that stays valid for 7 days.',
  },
  {
    route: routes.FINANCIALS,
    target: null,
    titleId: 'tour.finale.title',
    defaultTitle: "That's the tour!",
    bodyId: 'tour.finale.body',
    defaultBody:
      'You can replay it anytime from the ? icon in the header. Happy selling!',
  },
];
